import React, { useState, useRef, useEffect,forwardRef, useImperativeHandle } from "react";
import "../assets/css/App.css"

const CustomDropdown = forwardRef((props) => {
const { options, selectedd, type, model3dId, model3dName } = props;
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);
  const handleSelect = (option) => {
    selectedd(option);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ width: "100%", position: "relative" }} ref={dropdownRef}>
      {/* Dropdown Box */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          height: "48px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px",
          cursor: "pointer",
          color: model3dId ? "black" : "#6B7280",
          userSelect: "none",
          fontWeight: "500",
          background: "#FFFFFF",
          border: '1px solid #CED4DA',
        }}
        // className="dropDownHover"
      >
        {model3dName || type}

        <span style={{ color: "black", fontSize: "14px" }}>
          {open ? "▲" : "▼"}
        </span>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "48px",
            left: "0",
            width: "100%",
            background: "#ffffff",
            maxHeight: "350px",
            // border: "1px solid gold",
            borderRadius: "8px",
            zIndex: 99,
            overflow: "auto",
            fontWeight: "500",
          }}
        >
          {options?.map((opt, index) => (
            <div
              key={index}
              onClick={() => handleSelect(opt)}
              style={{
                padding: "10px",
                color: "black",
                cursor: "pointer",
                transition: "0.2s",
                background: model3dId === opt.id ? "#6B7280" : "transparent",
              }}
              onMouseEnter={(e) =>
                (e.target.style.background = "#6B7280")
              }
              onMouseLeave={(e) =>
                (e.target.style.background =
                  model3dId === opt.id ? "#6B7280" : "transparent")
              }
            >
              {opt.modelName}
            </div>
          ))}
        </div>
      )}
    </div>
  );
})
 export default CustomDropdown;